import Icon from '../components/Icon.vue'

Icon.register({"plug":{"width":384,"height":512,"paths":[{"d":"M256 144V32C256 14.3 270.3 0 288 0S320 14.3 320 32V144H256zM368 160H16C7.2 160 0 167.2 0 176V208C0 216.8 7.2 224 16 224H32V256C32 333.4 87 398 160 412.8V512H224V412.8C297 398 352 333.4 352 256V224H368C376.8 224 384 216.8 384 208V176C384 167.2 376.8 160 368 160zM128 144V32C128 14.3 113.7 0 96 0S64 14.3 64 32V144H128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/plug.js
// module id = null
// module chunks = 